import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;

	width: 100%;
	height: 150px;
`;

export const ContainerButtons = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

export const ContainerPermissionButtons = styled.div`
	display: flex;
	padding: 0 20px;

	button:nth-child(1) {
		margin-right: 30px;
	}
`;

export const ContainerScheduleButtons = styled.div`
	display: flex;
	padding: 0 20px;

	& > button > p {
		margin-right: 5px;
	}
`;

export const Icon = styled.div`
	margin-top: -20px;
	height: 20px;

	.hoverText {
		position: relative;
	}

	.hoverTextLeft:before {
		content: attr(data-hover);
		width: max-content;
		visibility: hidden;
		opacity: 0;
		background-color: black;
		color: #fff;
		text-align: center;
		border-radius: 5px;
		padding: 5px 5px;
		transition: opacity 1s ease-in-out;

		position: absolute;
		z-index: 1;
		right: 30px;
		top: 0px;
	}

	.hoverTextLeft:hover:before {
		opacity: 1;
		visibility: visible;
	}

	.hoverTextRight:before {
		content: attr(data-hover);
		width: max-content;
		visibility: hidden;
		opacity: 0;
		background-color: black;
		color: #fff;
		text-align: center;
		border-radius: 5px;
		padding: 5px 5px;
		transition: opacity 1s ease-in-out;

		position: absolute;
		z-index: 1;
		left: 30px;
		top: 0px;
	}

	.hoverTextRight:hover:before {
		opacity: 1;
		visibility: visible;
	}
`;
